import { j as e } from "./atoms-v218.js";
import { Label as s, Radio as d } from "./atoms-v2731.js";
import { SkeletonRow as l } from "./atoms-v2778.js";
const n = ({ ariaLabel: i, className: r, id: t, name: o, value: a }) => /* @__PURE__ */ e.jsxs(s, { $isSkeleton: !0, "aria-hidden": "true", "aria-label": i, className: r, children: [
  /* @__PURE__ */ e.jsx(d, { disabled: !0, id: t || o, name: o, type: "radio", value: a }),
  /* @__PURE__ */ e.jsx(l, { height: "8px" })
] });
export {
  n as RadioSkeleton
};
